import React from 'react';

import { Paragraph } from 'components';
import { FeatureItem, StyledIcon } from 'apps/modals/plans';
import { RolesAndAccessControlLink } from 'constants/subscription';

export const plans: { [key: string]: Array<string | React.ReactNode> } = {
  free: [
    '20 GB of cloud storage',
    'Unlimited Viewers',
    '30-day version control history',
    '5 CAD File Conversions/Month',
  ],
  pro: [
    '100 GB of private Cloud Storage',
    'Unlimited version control history',
    'Unlimited CAD conversions',
    'Unlimited CAD chat history',
    'Unlimited annotations',
    '10 AutoDFM/Month (coming soon)',
    'Simplified billing per seat',
    <span key='role'>
      Team{' '}
      <a href={RolesAndAccessControlLink} target='_blank' rel='noreferrer'>
        Roles & Access Controls
      </a>
    </span>,
    'Customer support(chat, email)',
  ],
  business: [
    'Unlimited Projects',
    '1TB of cloud storage',
    'Unlimited viewers',
    'Unlimited version control history',
    'Conflict Resolution',
    'CAD File Conversions',
    <span key='file-sync-app'>File Syncing App </span>,
    'Roles & Access Controls',
    'Priority Support',
    'Account Manager',
  ],
};

interface ProductPlanProps {
  productType: 'free' | 'pro' | 'business';
  className?: string;
}

export const ProductPlan = (props: ProductPlanProps) => {
  const { productType, className } = props;

  const plan = plans[productType];

  return (
    <div className={`${className}`}>
      {plan.map(feature => (
        <FeatureItem key={feature}>
          <StyledIcon name='check' />
          <Paragraph>{feature}</Paragraph>
        </FeatureItem>
      ))}
    </div>
  );
};
